import * as React from 'react';
const VisaIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="metodi_pagamento_icon"
      data-name="metodi pagamento icon"
      viewBox="0 0 89.71 29"
      {...props}
    >
      <defs>
        <style>{`.visa-icon{fill:${fill};fill-rule:evenodd}`}</style>
      </defs>
      <path
        d="M25.49.52 18.38 19.7l-.75-3.9c-1.72-4.65-5.07-8.88-10.05-11.74l6.49 24.55h7.69L33.2.52h-7.71M31.59 28.63 36.11.5h7.27l-4.53 28.13h-7.26zM65.16 1.19C63.72.62 61.45 0 58.67 0c-7.19 0-12.24 3.81-12.26 9.28-.05 4.05 3.61 6.29 6.37 7.64 2.84 1.39 3.78 2.26 3.76 3.48-.02 1.89-2.26 2.74-4.35 2.74-2.91 0-4.45-.42-6.81-1.47l-.95-.45-1.02 6.29c1.69.8 4.83 1.47 8.08 1.49 7.61 0 12.58-3.78 12.63-9.6.02-3.21-1.92-5.65-6.12-7.64-2.54-1.29-4.1-2.16-4.08-3.48 0-1.17 1.32-2.41 4.18-2.41 2.39-.05 4.08.5 5.42 1.07l.65.32.99-6.07M83.79.52h-5.6c-1.74 0-3.03.5-3.81 2.34L63.61 28.63h7.64s1.24-3.46 1.52-4.23c.85 0 8.23.02 9.3.02.22.97.9 4.2.9 4.2h6.74L83.79.52m-8.95 18.13 2.91-7.86c-.05.07.57-1.64.97-2.69l.47 2.44s1.39 6.72 1.69 8.11h-6.04Z"
        className="visa-icon"
      />
      <path
        d="M11.79.52H.07L0 .99c9.1 2.34 15.1 8.06 17.61 14.8L15.07 2.88C14.65 1.09 13.38.57 11.79.52"
        className="visa-icon"
      />
    </svg>
  );
};
export default VisaIcon;
